<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="users_settings" @selected="switchTab"></TabsWidget>
    </div>
    <div class="wrapper-body">
      <div class="header-panel">
        <div class="tabs-widget">
          <div class="tab-item" :class="{ active: activeTab == 'event_gatekeeper' }"
            @click="switchSubTab('event_gatekeeper')">
            EVENT GATEKEEPER
          </div>
          <div class="h-spacer"></div>
          <div class="tab-item" :class="{ active: activeTab == 'ticket_sellers' }"
            @click="switchSubTab('ticket_sellers')">
            TICKET SELLERS
          </div>
        </div>
      </div>
      <eventGatekeeper v-if="activeTab == 'event_gatekeeper'"></eventGatekeeper>
      <ticketSellers v-if="activeTab == 'ticket_sellers'"></ticketSellers>
    </div>
  </div>
</template>

<script>
import eventGatekeeper from "./components/event_gatekeeper.vue";
import ticketSellers from "./components/ticketSellers.vue";
import TabsWidget from "./components/TabsWidget.vue";
export default {
  components: {
    eventGatekeeper,
    TabsWidget,
    ticketSellers
  },
  sockets: {},
  data: () => ({
    activeTab: "event_gatekeeper",
  }),
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    switchSubTab(tab) {
      let vm = this;
      vm.activeTab = tab;
    }
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;

  @media (max-width:650px) {
    flex-direction: column;
  }


  .wrapper-header {
    height: 100%;
    width: 250px;
    background: #fff;
    border-right: 1px solid #ddd;
  }

  .wrapper-body {
    width: calc(100% - 250px);
    display: flex;
    background: #fff;
    flex-direction: column;

    @media (max-width: 650px) {
      width: 100%;
      height: calc(100% - 70px);
    }

    .header-panel {
      height: 55px;
      border-bottom: 1px solid #ddd;

      .tabs-widget {
        display: flex;
        align-items: flex-end;
        margin-right: 15px;

        .h-spacer {
          margin-right: 20px;
        }

        .tab-item {
          cursor: pointer;
          padding: 14px 4px;
          border-bottom: 3px solid transparent;
          white-space: nowrap;

          &.active {
            color: var(--wecodefy-secondary-color, #9fc953);
            border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
          }
        }
      }
    }

  }
}
</style>
